import axios from '../../http';

const state = {
  tariffDetails: {
    tariffDetails: []
  },
  existingProjection: {
    electricityChosenPersonalProjectionPlan: null,
    electricityDefaultPersonalProjectionPlan: null,
    gasChosenPersonalProjectionPlan: null,
    gasDefaultPersonalProjectionPlan: null
  },
  newProjection: {
    electricityChosenPersonalProjectionPlan: null,
    electricityDefaultPersonalProjectionPlan: null,
    gasChosenPersonalProjectionPlan: null,
    gasDefaultPersonalProjectionPlan: null
  },
  newTil: {
    electricityTariffInformationLabel: null,
    gasTariffInformationLabel: null
  },
  existingTil: {
    electricityTariffInformationLabel: null,
    gasTariffInformationLabel: null
  }
};

const getters = {};

const actions = {
  async getTariffDetails({ rootState, commit, dispatch }, tariffId) {
    try {
      const { switchId, switchType, proposedPayMethod } = rootState.storage.quote;

      await dispatch('page_loader/start', 0, { root: true });

      const tariffDetailsResponse = await axios({
        method: 'POST',
        url: '/request/tariffs/tariff/information',
        data: { tariffId }
      });

      commit('updateState', {
        prop: 'tariffDetails',
        value: { ...tariffDetailsResponse.data.tariffInfoDto, tariffId }
      });

      const model = {
        proposedPayMethod,
        switchId,
        switchType,
        tariffId,
        tariffValidToDate: null
      };

      const existingTilResponse = await axios({
        method: 'POST',
        url: '/request/til',
        data: {
          onCurrentTariff: true,
          ...model
        }
      });

      commit('updateState', {
        prop: 'existingTil',
        value: existingTilResponse.data.tilDto
      });

      const newTilResponse = await axios({
        method: 'POST',
        url: '/request/til',
        data: {
          onCurrentTariff: false,
          ...model
        }
      });

      commit('updateState', {
        prop: 'newTil',
        value: newTilResponse.data.tilDto
      });

      const existingProjectionResponse = await axios({
        method: 'POST',
        url: '/request/ppp',
        data: {
          onCurrentTariff: true,
          ...model
        }
      });

      commit('updateState', {
        prop: 'existingProjection',
        value: existingProjectionResponse.data.pppDto
      });

      const newProjectionResponse = await axios({
        method: 'POST',
        url: '/request/ppp',
        data: {
          onCurrentTariff: false,
          ...model
        }
      });

      commit('updateState', {
        prop: 'newProjection',
        value: newProjectionResponse.data.pppDto
      });

      dispatch('page_loader/stop', null, { root: true });
      return res;
    } catch (error) {
      dispatch('page_loader/stop', null, { root: true });
      return error;
    }
  }
};

const mutations = {
  updateState(state, { prop, value }) {
    state[prop] = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
